import React, { CSSProperties } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { ListingColumn, RowAction } from './listing'
import { MoreVertical } from 'react-feather'
import MoreMenuToggle from '../dropdown/toggle'

const itemRender = <T,>(
	item: T,
	others: {
		hasSelectedActions: boolean | undefined
		hasIndividualActions: boolean | undefined
		individualActions: ((item: T) => RowAction[]) | undefined
		allowCsvExport: boolean | undefined
		columns: ListingColumn<T>[]
		getIDFunc: (item: T) => string
		selectFilter: string[]
		setSelectFilter: (selectFilter: string[]) => void
		setSelect: (id: string, checked: boolean) => void
	}
) => (
	<>
		{(others.hasSelectedActions || others.allowCsvExport) && (
			<td style={styles.selectTd}>
				<div className="center-flex">
					<Form.Control
						style={styles.formCheckbox}
						onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
							others.setSelect(event.target.value, event.target.checked)
						}}
						type="checkbox"
						id={`select_${others.getIDFunc(item)}`}
						name={`select_${others.getIDFunc(item)}`}
						checked={others.selectFilter.find((select) => select === others.getIDFunc(item)) !== undefined}
						value={others.getIDFunc(item)}
					/>
				</div>
			</td>
		)}
		{others.columns.map((column, colIndex) => (
			<td
				key={`${others.getIDFunc(item)}_col_${colIndex}`}
				colSpan={column.colSpan ? column.colSpan(item) : undefined}
				hidden={column.hidden ? column.hidden(item) : undefined}
				style={{ width: column.width || 'inherit' }}
			>
				{column.render(item)}
			</td>
		))}
		{others.hasIndividualActions && (
			<td>
				<Dropdown>
					<Dropdown.Toggle
						as={MoreMenuToggle}
						className="form dropdown-toggle-long"
						variant="secondary"
						id="dropdown-row-action"
						style={{ width: '300px', height: '40px' }}
					>
						<MoreVertical />
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{others.individualActions!(item).map((action, i) => (
							<Dropdown.Item
								key={i}
								disabled={action.disabled}
								onClick={async () => {
									await action.method(others.getIDFunc(item))
									others.setSelectFilter([])
								}}
							>
								{action.name}
							</Dropdown.Item>
						))}
					</Dropdown.Menu>
				</Dropdown>
			</td>
		)}
	</>
)

const styles = {
	formCheckbox: {
		boxShadow: 'none',
		width: '16px',
		height: '16px',
		appearance: 'revert',
	} as CSSProperties,
	selectTd: { verticalAlign: 'middle' },
}

export default itemRender
